import * as React from 'react';
import { connect } from 'react-redux';
import { fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, userTypeIds, updateListUsuarios } from '../../actions/usuariosActions';
import { fetchSeller } from '../../actions/sellersActions';
import { editUser, putActivarUsuario, putPausarUsuario, deshabilitarMfaUsuarioApi, obtenerTiposUsuarioApi, impersonateUserApi, requestTokenResetPasswordAdmin, postSearchTokenUsuario } from '../../api/axios';
import { toast } from 'react-toastify';
import { isEmail } from '../../utilities/formatString';
import PasswordValidation from './PasswordValidation';
import GoBackArrow from '../General/GoBackArrow';
import BigSpinner from '../General/BigSpinner';
import Auth from '../../auth';
import '../General/AdminListCard.css';
import { encryptPassword } from '../../utilities/encryptPassword';
import { withNavigation } from '../General/withNavigation';
import UserSidebarItems from './UserSidebarItems';
import { Modal, Button } from 'react-bootstrap';

class UserEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            didEdit: false,
            usuarioError: false,
            password: "",
            confirmPassword: "",
            passValidation: false,
            showPassword: false,
            showConfirmPassword: false,
            hiddenItems: [],
            soloLectura: false,
            activo: true,
            showSpinner: false,
            localTipoUsuario: 0,
            localIdUsuario: 0,
            token: '',
            limiteCaracteresExcedido: false,
            tiposUsuario: [],
            showConfirmModal: false,
            showMfaConfirmModal: false,
            showImpersonationModal: false,
            impersonationLoading: false
        };
        this.emailUsuarioInputRef = React.createRef();
        this.tiposUsuario = [
            { value: 1, label: "Category" },
            { value: 6, label: "Solo Lectura" },
            { value: 7, label: "Proveedor" }
        ];
    };

    parseResetTokenResponse = (raw) => {
        let res = raw;
        if (typeof raw === "string") {
            try {
                res = JSON.parse(raw);
            } catch (_) {
                res = {};
            }
        }
        const token =
            res?.token ||
            res?.Token ||
            res?.resetToken ||
            res?.ResetToken ||
            res?.tokenResetPassword ||
            "";
        return (token || "").trim();
    };

    getIdUsuarioForToken = () => {
        const usuario = this.props.usuario || {};
        return usuario?.idUsuario || usuario?.IdUsuario || this.state.localIdUsuario;
    };

    fetchTokenUsuario = async (showToastOnError = false) => {
        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;
        if (isResetMode) return "";

        const idUsuario = this.getIdUsuarioForToken();
        if (!idUsuario || isNaN(Number(idUsuario)) || Number(idUsuario) <= 0) return "";

        try {
            const res = await postSearchTokenUsuario({ idUsuario: Number(idUsuario) });
            const token = this.parseResetTokenResponse(res?.data);
            this.setState({ token: token || "" });
            return token || "";
        } catch (err) {
            // If token doesn't exist yet, Core may respond 400. Do not treat as a UI error.
            if (showToastOnError) {
                toast.error("No se pudo consultar el token.");
            }
            this.setState({ token: "" });
            return "";
        }
    };

    copyResetTokenToClipboard = async () => {
        const token = (this.state.token || "").trim();
        if (!token) return;

        try {
            if (navigator?.clipboard?.writeText) {
                await navigator.clipboard.writeText(token);
                toast.success("Token copiado al portapapeles.");
                return;
            }

            const textArea = document.createElement("textarea");
            textArea.value = token;
            textArea.setAttribute("readonly", "");
            textArea.style.position = "absolute";
            textArea.style.left = "-9999px";
            document.body.appendChild(textArea);
            textArea.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(textArea);
            ok ? toast.success("Token copiado al portapapeles.") : toast.error("No se pudo copiar el token.");
        } catch (_) {
            toast.error("No se pudo copiar el token.");
        }
    };

    componentDidMount() {
        const { usuario, match } = this.props;
        const userIdFromUrl = match?.params?.id;
        const { isResetMode, username } = this.props.location?.state || {};

        if (userIdFromUrl && userIdFromUrl != "0") {
            if (!usuario || usuario.idUsuario != userIdFromUrl || JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]") {
                this.props.fetchUsuario({ idUsuario: userIdFromUrl });
            } else {
                this.initializeUser(usuario, true);
            }
        } else if (userIdFromUrl == "0") {
            // Si estamos en modo reset con un username disponible, buscar el usuario por nombre
            // (esto ocurre cuando Login no devuelve el userId correctamente y navega a /Editar/0)
            if (isResetMode && username) {
                this.props.fetchUsuario({ usuario: username });
            } else {
                this.props.resetUsuario();
                this.initializeUser({
                    idUsuario: 0,
                    identificadores: [],
                    soloLectura: false,
                    baja: false,
                    tipoUsuario: 0
                }, true);
            }
        } else if (isResetMode && username) {
            this.props.fetchUsuario({ usuario: username });
        } else {
            if ((JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]") && !isResetMode) {
                this.goBack();
            } else {
                this.initializeUser(usuario, true);
            }
        }
        this.fetchTiposUsuario();
    }

    fetchTiposUsuario = () => {
        obtenerTiposUsuarioApi().then(res => {
            if (res.data && Array.isArray(res.data)) {
                this.setState({ tiposUsuario: res.data });
            } else if (Array.isArray(res)) {
                this.setState({ tiposUsuario: res });
            }
        }).catch(err => {

        });
    }

    componentDidUpdate(prevProps) {
        const userIdFromUrl = this.props.match?.params?.id;

        // If in Create Mode (ID 0), do not react to props.usuario updates to prevent stale data injection
        if (userIdFromUrl === "0") return;

        if (this.props.usuario && this.props.usuario !== prevProps.usuario && JSON.stringify(this.props.usuario) !== "{}" && JSON.stringify(this.props.usuario) !== "[]") {
            this.initializeUser(this.props.usuario);
        }
    }

    initializeUser = (usuario, focusEmail = false) => {
        const hiddenItems = Array.isArray(usuario?.perfil)
            ? usuario.perfil
            : (Array.isArray(usuario?.identificadores) ? usuario.identificadores : []);

        this.setState({
            hiddenItems,
            soloLectura: usuario.soloLectura,
            activo: !usuario.baja,
            localTipoUsuario: usuario.tipoUsuario,
            localIdUsuario: usuario.idUsuario || usuario.IdUsuario
        }, () => {
            // Try to consult token if it exists; ignore errors if not created yet.
            this.fetchTokenUsuario(false);
            if (focusEmail && this.emailUsuarioInputRef.current) {
                this.emailUsuarioInputRef.current.focus();
            }
        });
    }

    changePassword = (e) => {
        const { value } = e.target;

        if (value.length > 12) {
            if (!this.state.limiteCaracteresExcedido) {
                toast.warn("Excede los 12 caracteres, verifique");
                this.setState({ limiteCaracteresExcedido: true });
            }
            return;
        }

        this.setState({
            password: value,
            limiteCaracteresExcedido: false
        });
    }

    handlePassValidation = (isSuccess) => {
        this.setState({ passValidation: isSuccess });
    };

    confirmPassword = (e) => {
        const { value } = e.target;
        this.setState({
            usuarioError: value !== this.state.password,
            confirmPassword: value
        });
    }

    myChangeHandler = (event) => {
        this.setState({ didEdit: true });
        const { name, value } = event.target;

        const cleanValue =
            name === "nombreUsuario" || name === "email"
                ? value.trimStart()
                : value;

        const usuarioActualizado = {
            ...this.props.usuario,
            [name]: cleanValue
        };
        this.props.editUsuario(usuarioActualizado);
    };


    updateHiddenItems = (hiddenItems) => {
        this.setState({ hiddenItems });
    };

    onSwitchChange = () => {
        const valueEstado = !this.state.soloLectura;

        this.setState({ soloLectura: valueEstado, didEdit: true });

        const usuarioActualizado = {
            ...this.props.usuario,
            soloLectura: valueEstado
        };

        this.props.editUsuario(usuarioActualizado);
    };


    onSwitchStateChange = () => {
        this.setState({ showConfirmModal: true });
    };

    handleConfirmSwitch = () => {
        const { activo, localIdUsuario } = this.state;
        const nuevoEstado = !activo; // Si está activo (true), el nuevo estado es falso (pausar). Si está inactivo (false), el nuevo estado es verdadero (activar).

        this.setState({
            showConfirmModal: false,
            activo: nuevoEstado,
            didEdit: true,
            showSpinner: true
        });

        const usuarioActualizado = {
            ...this.props.usuario,
            activo: nuevoEstado
        };

        this.props.editUsuario(usuarioActualizado);

        let requestPromise;

        // Si actualmente está activo (activo=true), queremos PAUSAR (apagar).
        // Si actualmente está inactivo (activo=false), queremos ACTIVAR (encender).
        if (activo) {
            // El estado actual es ON, el usuario hizo clic para apagar -> Llamar a Pausar
            requestPromise = putPausarUsuario(localIdUsuario);
        } else {
            // El estado actual es OFF, el usuario hizo clic para encender -> Llamar a Activar
            requestPromise = putActivarUsuario(localIdUsuario);
        }

        requestPromise
            .then(() => {
                toast.success("Estado editado exitosamente");
                // NO volvemos atrás, solo actualizamos el estado.
            })
            .catch(err => {
                // Revertir estado en caso de error
                this.setState({ activo: activo });
                if (err.response?.data?.errores) {
                    err.response.data.errores.forEach(error => toast.error(error));
                } else {
                    toast.error("No pudo editarse");
                }
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleCloseModal = () => {
        this.setState({ showConfirmModal: false });
    };

    handleTipoUsuarioChange = (selectedOption) => {
        const nuevoTipo = selectedOption.value;
        this.setState({
            localTipoUsuario: nuevoTipo,
            didEdit: true
        });

        const usuario = {
            ...this.props.usuario,
            tipoUsuario: nuevoTipo
        };
        this.props.editUsuario(usuario);
    };


    onSubmit = async (event) => {
        event.preventDefault();

        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        // Use props usage but default to empty/0 if missing in Reset Mode
        const { email, nombreUsuario, idUsuario = (isResetMode ? 0 : undefined), idSeller, soloLectura, activo } = this.props.usuario || {};
        const { localTipoUsuario } = this.state;

        if (!isResetMode && !isEmail(email)) {
            if (email === "") {
                toast.warn("Ingrese un e-mail de usuario");
                return;
            }
            toast.warn("Mail incorrecto");
            return;
        }

        if (!isResetMode && nombreUsuario === "") {
            toast.warn("Ingrese un nombre de usuario");
            return;
        }

        // if (this.state.passValidation) {
        //     toast.warn("La contraseña no cumple con los requisitos");
        //     return;
        // }

        if (idUsuario === this.props.idUsuario && this.state.usuarioError) {
            toast.warn("Las contraseñas no coinciden");
            return;
        }

        const { password, hiddenItems } = this.state;


        // Determine effective ID and fallback values for Reset Mode
        let effectiveId = idUsuario;
        let effectiveEmail = email;
        let effectiveUsuario = nombreUsuario;

        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            // Primera opción: ID en la URL (el más confiable — el Login navega a /Usuarios/Editar/${userId})
            const urlId = this.props.match?.params?.id;
            if (urlId && urlId !== "0" && !isNaN(Number(urlId))) {
                effectiveId = Number(urlId);
            }
            // Segunda opción: ID de la sesión en Redux
            else if (this.props.idUsuario && this.props.idUsuario > 0) {
                effectiveId = this.props.idUsuario;
            }
            // Fallback a location state username si los datos del usuario no cargaron aún
            if (!effectiveEmail && this.props.location?.state?.username) {
                effectiveEmail = this.props.location.state.username;
            }
            if (!effectiveUsuario && this.props.location?.state?.username) {
                effectiveUsuario = this.props.location.state.username;
            }
        }

        // En modo reset, si no se cargó el tipo del usuario todavía (queda en 0),
        // usar el tipo de la sesión activa como fallback para no enviar idTipoUsuario: 0 al Core API.
        const effectiveTipoUsuario = (localTipoUsuario && localTipoUsuario > 0)
            ? localTipoUsuario
            : (this.props.currentUserType || 0);

        let userUpdated = {
            idUsuario: effectiveId,
            idSeller: idSeller,
            email: effectiveEmail,
            usuario: effectiveUsuario ? effectiveUsuario.trim() : undefined,
            soloLectura: soloLectura,
            identificadores: hiddenItems,
            tipoUsuario: effectiveTipoUsuario,
            baja: !this.state.activo,
            modulos: []
        };

        if (password && password.length > 0) {
            userUpdated.nuevoPassword = encryptPassword(password);

            if (isResetMode && this.props.location?.state?.resetToken) {
                userUpdated.passwordActual = encryptPassword(this.props.location.state.resetToken);
            } else if (this.props.userCredentials?.password) {
                userUpdated.passwordActual = this.props.userCredentials.password;
            } else {
                userUpdated.passwordActual = "";
            }
        } else {
            userUpdated.nuevoPassword = "";
        }

        // Only unset if we still don't have an ID (which shouldn't happen if session is active)
        if (isResetMode && (!effectiveId || effectiveId === 0)) {
            userUpdated.email = undefined;
            userUpdated.usuario = undefined;
        }

        this.setState({ showSpinner: true });

        try {
            await editUser(userUpdated);
            toast.success("Usuario editado exitosamente");

            try {
                if (this.props.usuarios && Array.isArray(this.props.usuarios)) {
                    this.props.updateListUsuarios(this.props.usuarios, userUpdated);
                }
            } catch (updateError) {

            }


            this.props.userType.isResetPassword ? this.onLogout() : this.goBack();

        } catch (err) {
            if (err.response?.data?.errores) {
                err.response.data.errores.forEach(error => toast.error(error));
            } else {
                toast.error("No pudo editarse");
            }
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    generateResetPasswordToken = async () => {
        const { userType } = this.props;
        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;
        if (isResetMode) return;

        const usuario = this.props.usuario || {};
        const email = (usuario?.email || "").trim();

        this.setState({ showSpinner: true });
        try {
            if (!email) {
                toast.warn("El usuario no tiene email cargado.");
                return;
            }
            if (!isEmail(email)) {
                toast.warn("Mail incorrecto.");
                return;
            }

            // This endpoint typically sends the email. It may or may not return the token in the response.
            const raw = await requestTokenResetPasswordAdmin(email);
            const tokenFromResponse = this.parseResetTokenResponse(raw);
            if (tokenFromResponse) {
                this.setState({ token: tokenFromResponse });
            }

            toast.success("Token solicitado. Se envió el correo al usuario.");

            // After requesting by email, try to fetch the token by idUsuario for display (if Core supports it once requested).
            await this.fetchTokenUsuario(false);
        } catch (err) {
            // In some environments the email is sent but the API responds non-2xx.
            toast.success("Token solicitado. Se envió el correo al usuario.");
            await this.fetchTokenUsuario(false);
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    onLogout = () => {
        Auth.logout();
        this.props.navigate("/login");
    }

    goBack = () => {
        this.props.resetUsuario()
        window.history.go(-1);
    }

    togglePasswordVisibility = () => {
        if (this.state.password.length === 0) {
            toast.warn("Ingrese contraseña");
            return;
        }
        this.setState(prevState => ({ showPassword: !prevState.showPassword }));
    };

    toggleConfirmPasswordVisibility = () => {
        if (this.state.confirmPassword.length === 0) {
            toast.warn("Confirme contraseña");
            return;
        }
        this.setState(prevState => ({ showConfirmPassword: !prevState.showConfirmPassword }));
    };

    handleDisableMfa = () => {
        this.setState({ showMfaConfirmModal: true });
    };

    handleCloseMfaModal = () => {
        this.setState({ showMfaConfirmModal: false });
    };

    executeDisableMfa = () => {
        const { usuario } = this.props;
        const request = {
            IdUsuario: usuario.idUsuario
        };

        this.setState({ showSpinner: true, showMfaConfirmModal: false });

        deshabilitarMfaUsuarioApi(request)
            .then(() => {
                toast.success("MFA deshabilitado correctamente");
                // Actualizar el estado del usuario para reflejar MFA deshabilitado
                const updatedUser = { ...usuario, mfaConfirmado: false };
                this.props.editUsuario(updatedUser);
            })
            .catch((error) => {
                console.error(error);
                toast.error("Error al deshabilitar MFA");
            })
            .finally(() => {
                this.setState({ showSpinner: false });
            });
    };

    handleOpenImpersonationModal = () => {
        if (!this.props.canImpersonate) {
            toast.error("No tenes permisos para impersonar usuarios.");
            return;
        }

        this.setState({ showImpersonationModal: true });
    };

    handleCloseImpersonationModal = () => {
        this.setState({ showImpersonationModal: false });
    };

    startImpersonation = () => {
        const { usuario, idUsuario, impersonation, canImpersonate } = this.props;

        if (impersonation?.isActive) {
            toast.warn("Finaliza la impersonacion actual antes de iniciar otra.");
            return;
        }

        if (!canImpersonate) {
            toast.error("No tenés permisos para impersonar usuarios.");
            return;
        }

        if (!usuario?.idUsuario || usuario.idUsuario == idUsuario) {
            toast.warn("Seleccioná otro usuario para impersonar.");
            return;
        }

        this.setState({ impersonationLoading: true });

        impersonateUserApi({ IdUsuario: usuario.idUsuario })
            .then((res) => {
                Auth.startImpersonation({
                    idSeller: res.idSeller,
                    userName: res.nombre,
                    tipoUsuario: res.tipoUsuario,
                    userId: res.userId,
                    hiddenItemsIds: res.hiddenItemsIds,
                    codProv: res.codProv,
                    impersonation: res.impersonation,
                    canImpersonate: !!res.canImpersonate
                }, res.token);

                this.setState({ showImpersonationModal: false });
                toast.success(`Ahora estas viendo la plataforma como ${res.nombre}`);
                this.props.navigate("/");
            })
            .catch((error) => {
                const errores = error?.response?.data;

                if (Array.isArray(errores)) {
                    errores.forEach(err => toast.error(err));
                } else if (Array.isArray(errores?.errores)) {
                    errores.errores.forEach(err => toast.error(err));
                } else {
                    toast.error(errores?.mensaje || "No se pudo iniciar la impersonacion");
                }
            })
            .finally(() => {
                this.setState({ impersonationLoading: false });
            });
    };

    render() {
        const { userType } = this.props;

        const isResetMode = userType?.isResetPassword || this.props.location?.state?.isResetMode;

        const isCreateMode = this.props.match?.params?.id == "0";

        let usuario = this.props.usuario;
        const isEmpty = !usuario || JSON.stringify(usuario) === "{}" || JSON.stringify(usuario) === "[]";

        if (isEmpty && (isResetMode || isCreateMode)) {
            usuario = {
                idUsuario: 0,
                email: isResetMode ? (this.props.location?.state?.username || "") : "",
                nombreUsuario: isResetMode ? (this.props.location?.state?.username || "") : "",
                soloLectura: false,
                baja: false,
                identificadores: [],
                tipoUsuario: 0
            };
        }

        if (!userType || !usuario || JSON.stringify(usuario) === "{}") {
            return (
                <div className="container py-4">
                    <div className="card admin-grupo-busqueda-shell border-0 bg-white admin-form-loading d-flex align-items-center justify-content-center py-5">
                        <BigSpinner />
                    </div>
                </div>
            );
        }

        // Permitir permisos de edición solo para Administrador Total (AdminMod=2) o Seller Admin
        const canEditUserItems = userType.isAdminMod || userType.isSellerAdmin;

        const rowSize = "col-12 col-sm-6";
        const colSize = (userType.isAdminMod || userType.isSellerAdmin) &&
            canEditUserItems ? "col-12" : "col-12 col-sm-6";

        const IconEye = (isHidden) => (
            <i className={`me-1 mdi mdi-eye${isHidden ? "" : "-off"} mdi-24px text-dark`} />
        );

        const switchButtonStyle = (isActive, disabled) => ({
            backgroundColor: isActive ? '#28a745' : '#e9ecef',
            color: isActive ? 'white' : '#6c757d',
            padding: '10px 25px',
            borderRadius: '30px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontWeight: '600',
            display: 'inline-block',
            userSelect: 'none',
            minWidth: '140px',
            textAlign: 'center',
            opacity: disabled ? 0.6 : 1,
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            border: isActive ? 'none' : '1px solid #ced4da',
            letterSpacing: '0.5px'
        });

        const isResetFlow = userType.isResetPassword || this.props.location?.state?.isResetMode;
        const canImpersonateTarget =
            !!this.props.canImpersonate &&
            !isResetFlow &&
            !isCreateMode &&
            !this.props.impersonation?.isActive &&
            !!usuario?.idUsuario &&
            this.props.idUsuario != usuario.idUsuario;

        return (
            <form autoComplete="off" onSubmit={this.onSubmit} className="form-horizontal form-material mb-0">
                <div className="container py-2">
                    <div className="card admin-grupo-busqueda-shell border-0 bg-white">
                        {isResetFlow ? (
                            <div className="admin-grupo-busqueda-header text-center py-4">
                                <img
                                    src="/img/logo-marketplace-megatone.png"
                                    alt="MegaMarket"
                                    style={{ maxWidth: '200px', marginBottom: '12px' }}
                                />
                                <p className="small text-body-secondary mb-0">Definí tu nueva contraseña para continuar.</p>
                            </div>
                        ) : (
                            <div className="admin-grupo-busqueda-header">
                                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                        <div
                                            onClick={() => {
                                                this.props.resetUsuario();
                                            }}
                                            style={{ cursor: 'pointer' }}
                                            role="presentation"
                                        >
                                            <GoBackArrow />
                                        </div>
                                        <div>
                                            <h4 className="mb-0 text-body fw-semibold">Editar usuario</h4>
                                            <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                                                Datos de cuenta, estado, MFA y permisos de acceso.
                                            </p>
                                        </div>
                                    </div>
                                    {canImpersonateTarget && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={this.handleOpenImpersonationModal}
                                        >
                                            <i className="fa fa-user-secret me-2" aria-hidden="true" />
                                            Impersonar usuario
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="card-body px-4 pb-4 pt-2">
                            <div className="row g-3">
                    <div className={rowSize}>
                        <div className="row g-3">

                            {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <>
                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label className="label-oscura">Email</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={usuario.email || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="usuario@dominio.com"
                                                name="email"
                                                autoComplete="off"
                                                ref={this.emailUsuarioInputRef}
                                            />
                                        </div>
                                    </div>

                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label className="label-oscura">Nombre de usuario</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={usuario.nombreUsuario || ""}
                                                onChange={this.myChangeHandler}
                                                placeholder="nombreUsuario"
                                                name="nombreUsuario"
                                                maxLength="40"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}


                            {/* Mostrar contraseña solo si es CreateMode o si el usuario NO es Category ni AdminMod */}
                            {(isCreateMode || (this.props.currentUserType != userTypeIds.isCategory && this.props.currentUserType != userTypeIds.isAdminMod)) && (
                                <>
                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label className="label-oscura">
                                                {userType.isResetPassword ? "Nueva contraseña" : "Contraseña"}
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type={this.state.showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    value={this.state.password}
                                                    onChange={this.changePassword}
                                                    autoComplete="new-password"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    onClick={this.togglePasswordVisibility}
                                                >
                                                    {IconEye(this.state.showPassword)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={colSize}>
                                        <div className="form-group">
                                            <label className="label-oscura">
                                                {userType.isResetPassword
                                                    ? "Confirmar nueva contraseña"
                                                    : "Confirmar contraseña"
                                                }
                                            </label>
                                            <div className="input-group">
                                                <input
                                                    type={this.state.showConfirmPassword ? "text" : "password"}
                                                    className={`form-control ${this.state.usuarioError ? "warning-input" : ""}`}
                                                    value={this.state.confirmPassword}
                                                    onChange={this.confirmPassword}
                                                    maxLength="12"
                                                    autoComplete="new-password"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    onClick={this.toggleConfirmPasswordVisibility}
                                                >
                                                    {IconEye(this.state.showConfirmPassword)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 d-inline">
                                        <label className="label-oscura" htmlFor="passwordValidation">Requisitos de contraseña</label>
                                        <PasswordValidation
                                            password={this.state.password}
                                            isValidPassword={this.handlePassValidation}
                                        />
                                    </div>
                                </>
                            )}




                            {/* Campo Token - solo visible para Category, AdminMod, SellerAdmin (con restricciones) */}
                            {!(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                                (this.props.currentUserType == userTypeIds.isCategory ||
                                    this.props.currentUserType == userTypeIds.isAdminMod ||
                                    (this.props.currentUserType == userTypeIds.isSellerAdmin &&
                                        (this.props.idUsuario == this.state.localIdUsuario || this.state.localTipoUsuario == userTypeIds.isSeller))) && (
                                    <div className={colSize}>
                                        <div className="form-group">
                                            <div className="d-flex gap-2">
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm flex-shrink-0 ${(this.state.token || "").trim().length > 0 ? "btn-outline-danger" : "background-rojo-megatone text-white border-0"}`}
                                                    onClick={() => {
                                                        const ok = window.confirm(
                                                            "Obtener token de reinicio de contraseña.\n\n" +
                                                            "Si el usuario ya tiene un token activo, se mostrará.\n" +
                                                            "Si no existía, esta acción puede generar uno nuevo.\n\n" +
                                                            "¿Continuar?"
                                                        );
                                                        if (!ok) return;
                                                        this.generateResetPasswordToken();
                                                    }}
                                                    disabled={this.state.showSpinner || !usuario?.email}
                                                    title="Obtiene el token (puede generar uno nuevo si no existía)"
                                                >
                                                    Obtener token
                                                </button>

                                                {(this.state.token || "").trim().length > 0 ? (
                                                    <div className="w-100">
                                                        <label className="mb-1">Token</label>
                                                        <div className="d-flex gap-2 align-items-center">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={this.state.token || ""}
                                                                readOnly
                                                            />
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary flex-shrink-0"
                                                                onClick={this.copyResetTokenToClipboard}
                                                                title="Copiar token al portapapeles"
                                                            >
                                                                Copiar
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                )}

                            <div className="col-12">
                                <hr className="my-3 opacity-25" />
                            </div>

                            {/* Dropdown Tipo de Usuario - Para Admin y Seller Admin */}
                            {(this.props.currentUserType == userTypeIds.isAdminMod || this.props.currentUserType == userTypeIds.isSellerAdmin) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 col-sm-6 mt-2">
                                    <div className="form-group">
                                        <label className="control-label font-weight-bold text-muted text-uppercase small" style={{ letterSpacing: '1px' }}>Tipo Usuario</label>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                className="form-control form-select shadow-sm"
                                                style={{
                                                    height: '48px',
                                                    borderRadius: '8px',
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none',
                                                    backgroundColor: '#fff',
                                                    border: '1px solid #ced4da',
                                                    paddingRight: '40px',
                                                    fontSize: '1rem',
                                                    color: '#495057',
                                                    cursor: 'pointer'
                                                }}
                                                value={this.state.localTipoUsuario || ""}
                                                onChange={(e) => this.handleTipoUsuarioChange({ value: parseInt(e.target.value) })}
                                                name="localTipoUsuario"
                                            >
                                                <option value="">Seleccione...</option>
                                                {this.state.tiposUsuario && this.state.tiposUsuario
                                                    .filter(tipo => this.props.currentUserType == userTypeIds.isAdminMod ? true : (tipo.id === userTypeIds.isSellerAdmin || tipo.id === userTypeIds.isSeller))
                                                    .map(tipo => (
                                                    <option key={tipo.id} value={tipo.id}>{tipo.descripcion}</option>
                                                ))}
                                            </select>
                                            <i
                                                className="mdi mdi-chevron-down"
                                                style={{
                                                    position: 'absolute',
                                                    right: '15px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    pointerEvents: 'none',
                                                    color: '#6c757d',
                                                    fontSize: '20px'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}


                            {(this.props.currentUserType == userTypeIds.isCategory || this.props.currentUserType == userTypeIds.isAdminMod) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 col-sm-6 mt-2">
                                    <div className="form-group">
                                        <label className="control-label font-weight-bold d-block mb-2 text-muted text-uppercase small" style={{ letterSpacing: '1px' }}>Usuario Activo</label>
                                        <div
                                            onClick={this.onSwitchStateChange}
                                            style={switchButtonStyle(this.state.activo, false)}
                                            className="d-flex align-items-center justify-content-center shadow-sm"
                                        >
                                            <i className={`mdi ${this.state.activo ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'} me-2`} style={{ fontSize: '1.2rem' }}></i>
                                            <span>{this.state.activo ? "ACTIVO" : "INACTIVO"}</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Estado MFA y Botón Deshabilitar */}
                            {(this.props.currentUserType == userTypeIds.isCategory || this.props.currentUserType == userTypeIds.isAdminMod || userType.isSellerAdmin) && !(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                                <div className="col-12 mt-2">
                                    <div className="admin-list-card p-3 admin-form-mfa-inner">
                                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                                            <div>
                                                <h6 className="mb-1 fw-semibold text-dark">Autenticación de dos factores (MFA)</h6>
                                                <p className="mb-0 text-muted small">Seguridad adicional para el inicio de sesión.</p>
                                            </div>
                                            <div className="flex-shrink-0">
                                                {usuario.mfaConfirmado ? (
                                                    <div className="d-flex flex-wrap align-items-center gap-2">
                                                        <span className="badge bg-success px-3 py-2 rounded-pill">MFA activo</span>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-danger btn-sm rounded-pill px-3"
                                                            onClick={this.handleDisableMfa}
                                                            disabled={this.state.showSpinner}
                                                        >
                                                            Deshabilitar
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span className="badge bg-secondary px-3 py-2 rounded-pill">MFA inactivo</span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Columna de Permisos */}
                    {canEditUserItems && !(userType.isResetPassword || this.props.location?.state?.isResetMode) &&
                        !((this.props.currentUserType === userTypeIds.isSellerAdmin) && (this.props.idUsuario == usuario.idUsuario)) && (
                            <div className="col-12 col-sm-6">
                                <div className="admin-list-card admin-permisos-card h-100 overflow-hidden">
                                    <div className="card-header bg-light bg-opacity-50 border-bottom py-3 px-3">
                                        <h5 className="mb-0 fw-semibold text-dark">Permisos de acceso</h5>
                                        <p className="small text-muted mb-0 mt-1">Módulos visibles para este usuario.</p>
                                    </div>
                                    <div className="card-body p-3">
                                        <UserSidebarItems
                                            tipoUsuario={this.state.localTipoUsuario}
                                            previousHiddenItems={this.state.hiddenItems}
                                            updateHiddenItems={this.updateHiddenItems}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                            </div>
                        </div>

                <div className="card-footer bg-transparent border-top px-4 py-3 text-end">
                    {!(userType.isResetPassword || this.props.location?.state?.isResetMode) && (
                        <button
                            type="button"
                            className="btn btn-sm btn-light me-2"
                            onClick={this.goBack}
                        >
                            Cancelar
                        </button>
                    )}
                    <button
                        type="submit"
                        className="btn btn-sm background-rojo-megatone px-4"
                        disabled={this.state.showSpinner}
                    >
                        {this.state.showSpinner ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" /> : null}
                        Guardar cambios
                    </button>
                </div>
                </div>
                </div>

                <Modal show={this.state.showConfirmModal} onHide={this.handleCloseModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.activo ? "Desactivar Usuario" : "Activar Usuario"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro de que deseas {this.state.activo ? "desactivar" : "activar"} este usuario?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModal}>
                            Cancelar
                        </Button>
                        <Button variant={this.state.activo ? "danger" : "success"} onClick={this.handleConfirmSwitch}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showImpersonationModal} onHide={this.handleCloseImpersonationModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Impersonar usuario</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Vas a ingresar como <strong>{usuario?.nombreUsuario || usuario?.email || "este usuario"}</strong> y vas a heredar su vista, permisos, <code>idUsuario</code>, <code>codProv</code> e <code>idSeller</code>.
                        <br />
                        <br />
                        Tu sesion actual quedara guardada temporalmente para que puedas volver desde el menu superior.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseImpersonationModal} disabled={this.state.impersonationLoading}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={this.startImpersonation} disabled={this.state.impersonationLoading}>
                            {this.state.impersonationLoading ? "Ingresando..." : "Confirmar impersonacion"}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.showMfaConfirmModal} onHide={this.handleCloseMfaModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Deshabilitar MFA</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        ¿Estás seguro de que deseas deshabilitar la autenticación de dos factores para este usuario?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseMfaModal}>
                            Cancelar
                        </Button>
                        <Button variant="danger" onClick={this.executeDisableMfa}>
                            Confirmar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </form >
        );
    }
}



const mapStateToProps = state => ({
    usuario: state.usuarios.usuario,
    usuarios: state.usuarios.usuarios,
    userType: state.general.userType,
    idUsuario: state.general.userId,
    currentUserType: state.general.tipoUsuario,
    userCredentials: state.general.userCredentials,
    impersonation: state.general.impersonation,
    canImpersonate: state.general.canImpersonate
});

export default withNavigation(connect(mapStateToProps, {
    fetchUsuario, editUsuario, resetUsuario, fetchUsuarios, fetchSeller, updateListUsuarios
})(UserEdit));
